import React__default__default from 'react';
import styles from '../../node_modules/@flixbus/honeycomb/assets/scss/layout/_grid.scss.js';
import PropTypes__default from 'prop-types';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { GRID_COL_SIZES } from './types.js';

var GridCol = function (_a) {
  var _b;
  var _c = _a.extraClasses,
    extraClasses = _c === void 0 ? '' : _c,
    children = _a.children,
    inline = _a.inline,
    size = _a.size,
    sm = _a.sm,
    md = _a.md,
    lg = _a.lg,
    xl = _a.xl,
    push = _a.push,
    pushSm = _a.pushSm,
    pushMd = _a.pushMd,
    pushLg = _a.pushLg,
    pushXl = _a.pushXl;
  var gridColBem = HoneyBem.init('col', styles);
  // `flix-col-` and `flix-push-` grid classes doesn't follow the BEM syntax,
  // using BEM mixes in order to assemble the resulting class string
  var colClassNames = gridColBem.mix((_b = {}, _b[extraClasses] = extraClasses, _b[gridColBem.b({
    inline: inline
  })] = !size, _b[HoneyBem.init("col-".concat(size), styles).b()] = size, _b[HoneyBem.init("col-".concat(sm, "-sm"), styles).b()] = sm, _b[HoneyBem.init("col-".concat(md, "-md"), styles).b()] = md, _b[HoneyBem.init("col-".concat(lg, "-lg"), styles).b()] = lg, _b[HoneyBem.init("col-".concat(xl, "-xl"), styles).b()] = xl, _b[HoneyBem.init("push-".concat(push), styles).b()] = push, _b[HoneyBem.init("push-".concat(pushSm, "-sm"), styles).b()] = pushSm, _b[HoneyBem.init("push-".concat(pushMd, "-md"), styles).b()] = pushMd, _b[HoneyBem.init("push-".concat(pushLg, "-lg"), styles).b()] = pushLg, _b[HoneyBem.init("push-".concat(pushXl, "-xl"), styles).b()] = pushXl, _b));
  return /*#__PURE__*/React__default__default.createElement("div", {
    className: colClassNames
  }, children);
};
GridCol.displayName = 'GridCol';
GridCol.defaultProps = {
  extraClasses: '',
  inline: false,
  size: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  push: null,
  pushSm: null,
  pushMd: null,
  pushLg: null,
  pushXl: null
};
GridCol.propTypes = {
  children: PropTypes__default.node.isRequired,
  extraClasses: PropTypes__default.string,
  inline: PropTypes__default.bool,
  size: PropTypes__default.oneOf(GRID_COL_SIZES),
  sm: PropTypes__default.oneOf(GRID_COL_SIZES),
  md: PropTypes__default.oneOf(GRID_COL_SIZES),
  lg: PropTypes__default.oneOf(GRID_COL_SIZES),
  xl: PropTypes__default.oneOf(GRID_COL_SIZES),
  push: PropTypes__default.oneOf(GRID_COL_SIZES),
  pushSm: PropTypes__default.oneOf(GRID_COL_SIZES),
  pushMd: PropTypes__default.oneOf(GRID_COL_SIZES),
  pushLg: PropTypes__default.oneOf(GRID_COL_SIZES),
  pushXl: PropTypes__default.oneOf(GRID_COL_SIZES)
};

export { GridCol, GridCol as default };
